var English = "İngilizce";
var French = "Fransızca";
var German = "Almanca";
var Italian = "İtalyanca";
var Japanese = "Japonca";
var Korean = "Korece";
var Portuguese = "Portekizce";
var Russian = "Rusça";
var Spanish = "İspanyolca";
var Bahasa = "Bahasa";
var Thai = "Tayca";
var Vietnamese = "Vietnamca";
var Turkish = "Türkçe";
var Arabic = "Arapça";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Çince-Basitleştirilmiş",
	"Chinese-Traditional": "Çince-Geleneksel",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
